import { defineMessages } from "react-intl";

export const messages = defineMessages({
  shippingZonesHeader: {
    id: "uULcph",
    defaultMessage: "Shipping",
    description: "header",
  },
  bulkDelete: {
    defaultMessage: "Delete shipping zones",
    id: "EwoyVr",
    description: "bulk remove button label",
  },
  searchShippingZones: {
    defaultMessage: "Search shipping zones...",
    id: "2fgaAQ",
    description: "search input placeholder",
  },
  createShippingZone: {
    id: "mIUNgR",
    defaultMessage: "Create shipping zone",
    description: "button",
  },
  shippingZonesConfig: {
    id: "u6V5I/",
    defaultMessage: "Change default weight unit",
    description: "shipping zones configuration",
  },
});
